import request from './request';
import Storage from "../utils/storageUtils";
/**
 * 提交贷款申请
 * @param {Object} params - 申请参数
 * @param {string} params.mobile - 手机号码
 * @param {string} params.smsCode - 短信验证码
 * @param {number} params.amount - 申请金额
 * @returns {Promise}
 */
export const submitLoanApplication = (params) => {
  return request({
    url: '/open/mobileH5/apply',
    method: 'POST',
    data: params
  });
};

export const uvApi = (channelCode,url) => {
  return request({
    url: '/open/mobileH5/i',
    method: 'POST',
    data: {channelCode,url}
  });
};

export const semiMd5GetProductInfo = (channel_code,check_no) => {
  return request({
    url: '/open/channel/semiMd5GetProductInfo',
    method: 'POST',
    data:{channel_code,check_no}
  });
};

export const semiMd5UserProductConfirm = (channel_code,check_no) => {
  return request({
    url: '/open/channel/semiMd5UserProductConfirm',
    method: 'POST',
     data:{channel_code,check_no}
  });
};

/**
 * 获取贷款产品信息
 * @returns {Promise}
 */
export const getLoanProductInfo = () => {
  return request({
    url: '/mobileH5/productInfo',
    method: 'GET'
  });
};


export const qualification = (args) => {
  return request({
    url: '/open/mobileH5/qualification',
    method: 'POST',
    data: args
  });
};
export const submitProduct = (channel_key, check_no, product_ids) => {
  return request({
    url: '/open/mobileH5/submitProduct',
    method: 'POST',
    data: { channel_key, check_no, product_ids }
  });
};
//广告列表
export const getAds = (channel_code) => {
  return request({
    url: '/open/Advertising/getList',
    method: 'POST',
    isECB: false,
    data: { channel_code }
  });
};
//匹配产品
export const pmatch = (channel_key, check_no) => {
  return request({
    url: '/open/mobileH5/match',
    method: 'POST',
    data: { channel_key, check_no }
  });
};


// 封装获取字典的方法
export const getDic = async () => {
  const cacheKey = "dic";
  // 1. 先从 localStorage 取缓存
  const cache = Storage.get(cacheKey);
  if (cache) {
    try {
      return JSON.parse(cache); // 命中缓存
    } catch (e) {
      console.warn("缓存解析失败，重新请求 API", e);
    }
  }

  // 2. 没有缓存再请求 API
  const res = await request({
    url: "/open/mobileH5/dictionary",
    method: "POST",
  });

  // 3. 缓存数据（可加过期时间控制）
  if (res) {
    Storage.set(cacheKey, JSON.stringify(res), 300);
  }

  return res;
};
export const getAgreement = (agreements_type, user) => {
  var args = { agreements_type };
  if (agreements_type == 'PERSONAL_INFO_SHARING' || agreements_type == 'LOAN_DISCLOSURE') {
    args = {
      agreements_type: agreements_type,
      mobile: user.mobile,
      name: user.name,
      identity: user.identity
    }
    Object.keys(args).forEach(key => {
      if (args[key] === '' || args[key] === undefined) {
        delete args[key];
      }
    });
  }
  return request({
    url: '/open/mobileH5/agreementsDetails',
    method: 'POST',
    data: args
  });
};

export const getUrl = (id, channel_code) => {
  return request({
    url: '/open/Advertising/getUrl',
    method: 'POST',
    isECB: false,
    data: { advertising_id: id, channel_code }
  });
};

/**
 * 发送短信验证码
 * @returns {Promise} 
 */
export const sendSmsCode = (mobile) => {

  return request({
    url: '/open/mobileH5/mobileCode',
    method: 'POST',
    data: { mobile }
  });
};
export const agreements = {
  'USER_REGISTRATION': '用户注册服务协议',
  'PERSONAL_INFO_COLLECTION': '个人信息收集协议',
  'PRIVACY_POLICY': '隐私政策',
  'PERSONAL_INFO_SHARING': '个人信息共享协议',
  'UNIFIED_LOGIN_CONTRACT': '统一登录协议',
  'LOAN_DISCLOSURE': '贷款披露协议',
}

